import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Services } from './components/Services';
import { FeaturedListings } from './components/FeaturedListings';
import { ImpactHighlights } from './components/ImpactHighlights';
import { Testimonials } from './components/Testimonials';
import { OurProcess } from './components/OurProcess';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WhyChooseUs />
      <Services />
      <FeaturedListings />
      <ImpactHighlights />
      <Testimonials />
      <OurProcess />
      <ContactForm />
      <Footer />
    </div>
  );
}